module.exports = "ApiWeb/assets/purify.min.js";